import { SiteSetting } from "app/umbraco/models/settings.model";
import getTextAlignment from "helpers/getTextAlignment";
import { useEffect, CSSProperties, useState } from "react";

const getCssProperties = (siteSettings?: SiteSetting) => {
    const styles = {} as any;

    styles["--font-heading1-style"] = siteSettings?.theme?.fontStyleHeading1 || "normal";
    styles["--font-heading2-style"] = siteSettings?.theme?.fontStyleHeading2 || "normal";
    styles["--font-heading3-style"] = siteSettings?.theme?.fontStyleHeading3 || "normal";
    styles["--font-heading4-style"] = siteSettings?.theme?.fontStyleHeading4 || "normal";
    styles["--font-heading5-style"] = siteSettings?.theme?.fontStyleHeading5 || "normal";
    styles["--font-heading6-style"] = siteSettings?.theme?.fontStyleHeading6 || "normal";

    const assignFontWeight = (themeFontWeight: number | undefined, cssVariableName: string): void => {
        if ([100, 200, 300, 400, 600, 700, 800, 900].includes(themeFontWeight || Infinity)) {
            styles[cssVariableName] = themeFontWeight;
        }
    };

    const assignThemeColor = (themeColor: string | undefined, cssVariableName: string): void => {
        if (typeof themeColor !== "undefined") {
            styles[cssVariableName] = themeColor;
        }
    };

    // font-weight
    assignFontWeight(siteSettings?.theme?.fontWeightHeading1, "--font-weight-heading1");
    assignFontWeight(siteSettings?.theme?.fontWeightHeading2, "--font-weight-heading2");
    assignFontWeight(siteSettings?.theme?.fontWeightHeading3, "--font-weight-heading3");
    assignFontWeight(siteSettings?.theme?.fontWeightHeading4, "--font-weight-heading4");
    assignFontWeight(siteSettings?.theme?.fontWeightHeading5, "--font-weight-heading5");
    assignFontWeight(siteSettings?.theme?.fontWeightHeading6, "--font-weight-heading6");
    // background color
    assignThemeColor(siteSettings?.theme?.backgroundColor, "--body-background-color");
    assignThemeColor(siteSettings?.theme?.borderColor, "--body-border-color");
    assignThemeColor(siteSettings?.theme?.primaryColor, "--primary-color");
    assignThemeColor(siteSettings?.theme?.secondaryColor, "--secondary-color");

    // background color
    // if (typeof (siteSettings?.theme?.backgroundColor) !== "undefined") {
    //     styles["--body-background-color"] = siteSettings?.theme?.backgroundColor;
    // }

    // if (typeof (siteSettings?.theme?.backgroundColor) !== "undefined") {
    //     styles["--body-background-color"] = siteSettings?.theme?.backgroundColor;
    // }

    // if (typeof (siteSettings?.theme?.borderColor) !== "undefined") {
    //     styles["--body-border-color"] = siteSettings?.theme?.borderColor;
    // }

    // if (typeof (siteSettings?.theme?.primaryColor) !== "undefined") {
    //     styles["--primary-color"] = siteSettings?.theme?.primaryColor;
    // }

    // if (typeof (siteSettings?.theme?.secondaryColor) !== "undefined") {
    //     styles["--secondary-color"] = siteSettings?.theme?.secondaryColor;
    // }

    // Font Adjustments

    if (typeof siteSettings?.theme?.fontAdjustmentButton !== "undefined" && siteSettings?.theme?.fontAdjustmentButton !== 100) {
        styles["--font-adjustment-button"] = `${siteSettings?.theme?.fontAdjustmentButton / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeader !== "undefined" && siteSettings?.theme?.fontAdjustmentHeader !== 100) {
        styles["--font-adjustment-header"] = `${siteSettings?.theme?.fontAdjustmentHeader / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentParagraph !== "undefined" && siteSettings?.theme?.fontAdjustmentParagraph !== 100) {
        styles["--font-adjustment-paragraph"] = `${siteSettings?.theme?.fontAdjustmentParagraph / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading1 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading1 !== 100) {
        styles["--font-adjustment-heading1"] = `${siteSettings?.theme?.fontAdjustmentHeading1 / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading2 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading2 !== 100) {
        styles["--font-adjustment-heading2"] = `${siteSettings?.theme?.fontAdjustmentHeading2 / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading3 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading3 !== 100) {
        styles["--font-adjustment-heading3"] = `${siteSettings?.theme?.fontAdjustmentHeading3 / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading4 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading4 !== 100) {
        styles["--font-adjustment-heading4"] = `${siteSettings?.theme?.fontAdjustmentHeading4 / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading5 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading5 !== 100) {
        styles["--font-adjustment-heading5"] = `${siteSettings?.theme?.fontAdjustmentHeading5 / 100}em`;
    }

    if (typeof siteSettings?.theme?.fontAdjustmentHeading6 !== "undefined" && siteSettings?.theme?.fontAdjustmentHeading6 !== 100) {
        styles["--font-adjustment-heading6"] = `${siteSettings?.theme?.fontAdjustmentHeading6 / 100}em`;
    }

    // Font Weight

    if (typeof siteSettings?.theme?.fontWeightHeader !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeader)) {
        styles["--font-weight-header"] = siteSettings?.theme?.fontWeightHeader;
    }

    if (typeof siteSettings?.theme?.fontWeightHeading1 !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeading1)) {
        styles["--font-weight-heading1"] = siteSettings?.theme?.fontWeightHeading1;
    }

    if (typeof siteSettings?.theme?.fontWeightHeading2 !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeading2)) {
        styles["--font-weight-heading2"] = siteSettings?.theme?.fontWeightHeading2;
    }

    if (typeof siteSettings?.theme?.fontWeightHeading3 !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeading3)) {
        styles["--font-weight-heading3"] = siteSettings?.theme?.fontWeightHeading3;
    }

    if (typeof siteSettings?.theme?.fontWeightHeading4 !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeading4)) {
        styles["--font-weight-heading4"] = siteSettings?.theme?.fontWeightHeading4;
    }

    if (typeof siteSettings?.theme?.fontWeightHeading5 !== "undefined" && [300, 400, 600, 700, 800, 900].includes(siteSettings?.theme?.fontWeightHeading5)) {
        styles["--font-weight-heading5"] = siteSettings?.theme?.fontWeightHeading5;
    }

    if (
        typeof siteSettings?.theme?.fontWeightHeading6 !== "undefined" &&
        [300, 400, 600, 700, 800, 900].includes(Number(siteSettings?.theme?.fontWeightHeading6 || 0))
    ) {
        styles["--font-weight-heading6"] = `${siteSettings?.theme?.fontWeightHeading6}`;
    }

    // Font Line Height

    if (siteSettings?.theme?.fontParagraphLineHeight && siteSettings?.theme?.fontParagraphLineHeight.length > 0) {
        styles["--font-line-height-paragraph"] = `${siteSettings?.theme?.fontParagraphLineHeight}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading1 && siteSettings?.theme?.fontLineHeightHeading1.length > 0) {
        styles["--font-line-height-heading1"] = `${siteSettings?.theme?.fontLineHeightHeading1}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading2 && siteSettings?.theme?.fontLineHeightHeading2.length > 0) {
        styles["--font-line-height-heading2"] = `${siteSettings?.theme?.fontLineHeightHeading2}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading3 && siteSettings?.theme?.fontLineHeightHeading3.length > 0) {
        styles["--font-line-height-heading3"] = `${siteSettings?.theme?.fontLineHeightHeading3}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading4 && siteSettings?.theme?.fontLineHeightHeading4.length > 0) {
        styles["--font-line-height-heading4"] = `${siteSettings?.theme?.fontLineHeightHeading4}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading5 && siteSettings?.theme?.fontLineHeightHeading5.length > 0) {
        styles["--font-line-height-heading5"] = `${siteSettings?.theme?.fontLineHeightHeading5}px`;
    }

    if (siteSettings?.theme?.fontLineHeightHeading6 && siteSettings?.theme?.fontLineHeightHeading6.length > 0) {
        styles["--font-line-height-heading6"] = `${siteSettings?.theme?.fontLineHeightHeading6}px`;
    }

    // Font Letter Spacing

    if (siteSettings?.theme?.fontButtonLetterSpacing && siteSettings?.theme?.fontButtonLetterSpacing.length > 0) {
        styles["--font-letter-spacing-button"] = `${siteSettings?.theme?.fontButtonLetterSpacing}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeader && siteSettings?.theme?.fontLetterSpacingHeader.length > 0) {
        styles["--font-letter-spacing-header"] = `${siteSettings?.theme?.fontLetterSpacingHeader}px`;
    }

    if (siteSettings?.theme?.fontParagraphLetterSpacing && siteSettings?.theme?.fontParagraphLetterSpacing.length > 0) {
        styles["--font-letter-spacing-paragraph"] = `${siteSettings?.theme?.fontParagraphLetterSpacing}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading1 && siteSettings?.theme?.fontLetterSpacingHeading1.length > 0) {
        styles["--font-letter-spacing-heading1"] = `${siteSettings?.theme?.fontLetterSpacingHeading1}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading2 && siteSettings?.theme?.fontLetterSpacingHeading2.length > 0) {
        styles["--font-letter-spacing-heading2"] = `${siteSettings?.theme?.fontLetterSpacingHeading2}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading3 && siteSettings?.theme?.fontLetterSpacingHeading3.length > 0) {
        styles["--font-letter-spacing-heading3"] = `${siteSettings?.theme?.fontLetterSpacingHeading3}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading4 && siteSettings?.theme?.fontLetterSpacingHeading4.length > 0) {
        styles["--font-letter-spacing-heading4"] = `${siteSettings?.theme?.fontLetterSpacingHeading4}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading5 && siteSettings?.theme?.fontLetterSpacingHeading5.length > 0) {
        styles["--font-letter-spacing-heading5"] = `${siteSettings?.theme?.fontLetterSpacingHeading5}px`;
    }

    if (siteSettings?.theme?.fontLetterSpacingHeading6 && siteSettings?.theme?.fontLetterSpacingHeading6.length > 0) {
        styles["--font-letter-spacing-heading6"] = `${siteSettings?.theme?.fontLetterSpacingHeading6}px`;
    }

    // Font Families

    if (siteSettings?.theme?.fontHeading && siteSettings?.theme?.fontHeading.length > 0) {
        const fontHeading = siteSettings?.theme?.fontHeading?.[0]?.content;
        styles["--font-heading-font-family"] = `${fontHeading?.typekitName}, sans-serif`;
    }

    if (siteSettings?.theme?.fontParagraph && siteSettings?.theme?.fontParagraph.length > 0) {
        const fontParagraph = siteSettings?.theme?.fontParagraph?.[0]?.content;
        styles["--font-paragraph-font-family"] = `${fontParagraph?.typekitName}, sans-serif`;
    }

    // Alignment

    if (siteSettings?.theme?.headlineAlignment) {
        styles["--headline-alignment"] = getTextAlignment(siteSettings?.theme?.headlineAlignment);
    }

    if (siteSettings?.theme?.textAlignment) {
        styles["--text-alignment"] = getTextAlignment(siteSettings?.theme?.textAlignment);
    }

    // Collins Widget

    assignThemeColor(siteSettings?.theme?.widgetBackgroundColor, "--widget-background-color");
    assignThemeColor(siteSettings?.theme?.widgetTextColor, "--widget-text-color");
    assignThemeColor(siteSettings?.theme?.widgetTextHoverColor, "--widget-text-hover-color");
    assignThemeColor(siteSettings?.theme?.widgetIconColor, "--widget-icon-color");
    assignThemeColor(siteSettings?.theme?.widgetBorderColor, "--widget-border-color");
    assignThemeColor(siteSettings?.theme?.widgetTimeListBackgroundColor, "--widget-time-list-background-color");

    // Fixr Widget

    if (siteSettings?.theme?.fixrGeneralFontSize) {
        styles["--general-font-size"] = `${siteSettings?.theme?.fixrGeneralFontSize}px`;
    }

    assignThemeColor(siteSettings?.theme?.fixrGeneralTextColor, "--general-text-color");
    assignThemeColor(siteSettings?.theme?.fixrCardLoadingBackgroundColor, "--fixr-general-loading-color");
    assignThemeColor(siteSettings?.theme?.fixrLinkColor, "--fixr-link-color");
    assignThemeColor(siteSettings?.theme?.fixrButtonColor, "--fixr-button-color");
    assignThemeColor(siteSettings?.theme?.fixrButtonBackgroundColor, "--fixr-button-background-color");
    assignThemeColor(siteSettings?.theme?.fixrCardBackgroundColor, "--fixr-card-background-color");
    assignThemeColor(siteSettings?.theme?.fixrCardFontColor, "--fixr-card-text-color");
    assignThemeColor(siteSettings?.theme?.fixrCardLoadingBackgroundColor, "--fixr-card-loading-color");
    assignThemeColor(siteSettings?.theme?.fixrModalTextColor, "--fixr-modal-text-color");
    assignThemeColor(siteSettings?.theme?.fixrModalBackgroundColor, "--fixr-modal-background-color");
    assignThemeColor(siteSettings?.theme?.fixrTicketBackgroundColor, "--fixr-ticket-button-background-color");
    assignThemeColor(siteSettings?.theme?.fixrTicketBorderColor, "--fixr-ticket-button-border-color");
    assignThemeColor(siteSettings?.theme?.fixrTicketColor, "--fixr-ticket-button-color");

    return styles;
};

export default (siteSettings?: SiteSetting): any => {
    const [result, setResult] = useState<CSSProperties>(getCssProperties(siteSettings));

    useEffect(() => {
        setResult(getCssProperties(siteSettings));
    }, [siteSettings]);

    return result;
};
